// frontend/src/components/citations/VoiceCollectionCitation.jsx

import { useTranslation } from 'react-i18next';
import CitationLabel from './CitationLabel';

const VoiceCollectionCitation = ({ collection, labelT = null }) => {
  const { t } = useTranslation();
  const citationT = labelT || t;

  const modifications = collection.modificationsApplied
    ?.map(mod => citationT(mod, mod)) // 🔥 clau → traducció (amb fallback)
    .join(', ');

  const citations = Array.isArray(collection.citations) ? collection.citations : [];

  return (
    <div>
      <CitationLabel>{citationT('collection')}</CitationLabel>
      <div>
        {/* Títol + descripció */}
        <span>
          {citationT(collection.collectionName, collection.collectionName)}
          {collection.collectionDescription &&
            ` — ${citationT(collection.collectionDescription, collection.collectionDescription)}`}
        </span>

        {citations.map((citation, index) => (
          <span key={`${citation.citationLink || citation.citationText || 'citation'}-${index}`}>
            {' '}
            {index > 0 && <br />}
            {citation.citationText}
            {citation.citationLink && (
              <>
                {' '}
                <a
                  href={citation.citationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {citation.citationLink}
                </a>
              </>
            )}
          </span>
        ))}

        <br />

        {/* Modificacions */}
        {modifications && (
          <>
            <em>{citationT('changes_made')}: {modifications}</em>
          </>
        )}

        <br /><br />
      </div>
    </div>
  );
};

export default VoiceCollectionCitation;
